import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { get } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { GamePlayerApi } from "states/api/gamePlayer";
import { formatNumber } from "_common/utils/formatValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import DataDetail from "./DataDetail";
import ItemRecord from "./ItemRecord";

export default function HistoryData() {
  const navigate = useNavigate();
  const [detail, setDetail] = useState();

  const { data, refetch } = useQuery(
    ["game-player", "list", "complete"],
    () =>
      GamePlayerApi.getList({
        params: {
          page: 1,
          limit: 10,
          type: "trade",
        },
      }),
    {
      staleTime: 300000,
    }
  );

  useEffect(() => {
    refetch();
    const interval = setInterval(() => {
      refetch();
    }, 30000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return detail ? (
    <DataDetail item={detail} onGetDetail={() => setDetail()} />
  ) : (
    <div className="mx-auto w-full">
      <div className="list-history-data bg-[#121420]">
        {get(data, "data", [])?.map((item) => (
          <ItemRecord item={item} onGetDetail={() => setDetail(item)} />
        ))}
      </div>
    </div>
  );
}
